/* unplugin-vue-components disabled */const { ref, onBeforeUpdate } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-7ec2f03a"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { style: { "gap": "5px", "display": "flex", "flex-direction": "column", "text-align-last": "start", "height": "inherit" } };
const _hoisted_2 = { class: "path-panel-wrap" };
const _hoisted_3 = { class: "create-panel" };
const _hoisted_4 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "轨迹列表", -1));
const _hoisted_5 = { style: { "text-align-last": "right" } };
const work_1 = require("@/store/modules/work");
const AutoPathPanel_vue_1 = tslib_1.__importDefault(require("@/views/design/components/AutoPathPanel.vue"));
const ManualPathPanel_vue_1 = tslib_1.__importDefault(require("@/views/design/components/ManualPathPanel.vue"));
const DeleteBtn_1 = tslib_1.__importDefault(require("@/components/DeleteBtn"));
const SensitiveInput_1 = tslib_1.__importDefault(require("@/components/SensitiveInput"));
const model_1 = require("@/model");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PathPanel',
    props: {
        robot: {
            type: model_1.Robot,
            required: true
        },
        onPathNameBeforeChange: {
            type: Function,
            default: () => true
        }
    },
    setup(__props) {
        const store = (0, work_1.useWork)();
        const pathMode = ref('');
        const pathModel = ref('auto');
        const pathDialogModel = ref(false);
        const props = __props;
        function handleDelPath(path) {
            props.robot.delPath(path.id);
        }
        const updateAutoPathName = () => {
            if (autoPathPanel.value) {
                autoPathPanel.value.refreshPathFromName();
            }
        };
        const autoPathPanel = ref();
        onBeforeUpdate(() => {
            updateAutoPathName();
        });
        return (_ctx, _cache) => {
            var _a;
            const _component_el_radio = (0, vue_2.resolveComponent)("el-radio");
            const _component_el_radio_group = (0, vue_2.resolveComponent)("el-radio-group");
            const _component_el_dialog = (0, vue_2.resolveComponent)("el-dialog");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_table_column = (0, vue_2.resolveComponent)("el-table-column");
            const _component_el_table = (0, vue_2.resolveComponent)("el-table");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(_component_el_dialog, {
                        modelValue: (0, vue_2.unref)(pathDialogModel),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((0, vue_2.isRef)(pathDialogModel) ? (pathDialogModel).value = $event : null)),
                        "append-to-body": false,
                        width: "95%",
                        title: "路径规划",
                        "align-center": ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_radio_group, {
                                modelValue: (0, vue_2.unref)(pathModel),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(pathModel) ? (pathModel).value = $event : null)),
                                style: { "flex-direction": "row", "gap": "5px" }
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_el_radio, {
                                        label: "auto",
                                        size: "large",
                                        border: "",
                                        style: { "margin": "0px" }
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("自动规划")
                                        ]),
                                        _: 1
                                    }),
                                    (0, vue_2.createVNode)(_component_el_radio, {
                                        label: "manual",
                                        size: "large",
                                        border: ""
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("手动规划")
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                ((0, vue_2.unref)(pathModel) == 'auto')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AutoPathPanel_vue_1.default, {
                                        key: 0,
                                        onOnSuccess: _cache[1] || (_cache[1] = ($event) => { pathModel.value = 'auto'; pathDialogModel.value = false; }),
                                        ref_key: "autoPathPanel",
                                        ref: autoPathPanel
                                    }, null, 512))
                                    : ((0, vue_2.unref)(pathModel) == 'manual')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ManualPathPanel_vue_1.default, { key: 1 }))
                                        : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        _: 1
                    }, 8, ["modelValue"]),
                    _hoisted_4,
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        false
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                key: 0,
                                onClick: _cache[3] || (_cache[3] = ($event) => (pathDialogModel.value = true)),
                                type: "primary"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)("新增轨迹")
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createVNode)(_component_el_table, {
                        data: ((_a = __props.robot) === null || _a === void 0 ? void 0 : _a.paths) || [],
                        stripe: ""
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_table_column, {
                                prop: "name",
                                label: "名称"
                            }, {
                                default: (0, vue_2.withCtx)((scope) => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(SensitiveInput_1.default), {
                                        model: scope.row.name,
                                        "onUpdate:model": ($event) => ((scope.row.name) = $event),
                                        maxlength: 15,
                                        "before-change": __props.onPathNameBeforeChange
                                    }, null, 8, ["model", "onUpdate:model", "before-change"])
                                ]),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_table_column, { label: "操作" }, {
                                default: (0, vue_2.withCtx)((scope) => [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(DeleteBtn_1.default), {
                                        onDelConfirm: ($event) => (handleDelPath(scope.row)),
                                        title: "是否删除该条轨迹?"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createVNode)(_component_el_button, null, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)("删除")
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onDelConfirm"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["data"])
                ])
            ]));
        };
    }
});
